const divideByThousand = (cost: number | string): string => {
    if (typeof cost === 'string') {
        cost = parseFloat(cost);
    }

    return new Intl.NumberFormat('ru', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(cost);
};

export default divideByThousand;
